import { ReactNode, useEffect, useState } from 'react';
import { SwitchTransition, Transition } from 'react-transition-group';
import { css, styled } from 'twin.macro';
import 'styled-components/macro';

export const loadingMessages = [
  'Loading... now is a good time to grab a cup of coffee',
  'One moment... the robots are calibrating',
  'Beep boop beep... loading...',
  'Loading... a cup of coffee might help',
  'The bits are flowing...',
  'Our magic loading bar is doing its thing. Hang tight!',
  "Patience is a virtue, and you're a virtuous user!",
  'Locating the white rabbit..',
  'Waking the hamsters..',
  'Colouring each pixel...',
  'Loading... because we refuse to teleport',
  'Hamsters at peak velocity',
  'Hamsters in overdrive',
  'Loading... the AI got distracted by cat videos again',
  'The hamsters are on a tea break',
  'Computer says... loading...',
  'Interfacing with the database...',
  'Powering up from a power nap...',
  'Go go power up...',
  'Powering up... like a robot in training',
  'Awaiting approval from the robot overlords',
  'Adding story telling magic...',
  'Spinning inter-webs...',
];

const CHANGE_TEXT_INTERVAL = 3000;

const FadeDiv = styled.div(({ state }: { state: string }) => [
  css`
    transition: 0.5s;
    opacity: ${state === 'entered' ? 1 : 0};
    display: ${state === 'exited' ? 'none' : 'block'};
  `,
]);

const FadeTransition = ({ children, ...rest }: { children: ReactNode }) => (
  <Transition timeout={200} unmountOnExit mountOnEnter {...rest}>
    {state => (
      <FadeDiv state={state} tw="text-white">
        {children}
      </FadeDiv>
    )}
  </Transition>
);

export const LoadingMessage = () => {
  const [message, setMessage] = useState(loadingMessages[0]);

  useEffect(() => {
    const interval = setInterval(() => {
      setMessage(loadingMessages[Math.floor(Math.random() * loadingMessages.length)]);
    }, CHANGE_TEXT_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  return (
    <SwitchTransition mode="out-in">
      <FadeTransition key={message}>
        <span data-testid="loading-message">{message}</span>
      </FadeTransition>
    </SwitchTransition>
  );
};
